export default "__VITE_ASSET__Bndx$Y8T__"